export const ACTION = {
  VIEW: 'view',
  ADD: 'add',
  EDIT: 'edit',
  DELETE: 'delete',
  REVIEW: 'review',
  COPY: 'copy',
  CREATE: 'create',
  CLONE: 'clone',
};
